<template>
  <div class="summary-container" v-if="roleType === 2">
    <div class="summary-title">合计</div>
    <div class="summary-item" v-for='(item,index) in summaryTitleList' :key="index">
      <div class="summary-item-label">{{item.title}}：</div>
      <div class="summary-item-value">{{summaryInfo[item.key] || 0}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryInfoList',
  props: {
    summaryInfo: {
      type: Object,
      default: () => {},
    },
    summaryTitleList: {
      type: Array,
      default: () => [],
    },
    roleType: {
      type: Number,
    },
  },
};
</script>

<style lang="less" scoped>
.summary-container {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .summary-title {
    margin-right: 16px;
  }
  .summary-item {
    display: flex;
    margin-right: 16px;
    .summary-item-value {
      min-width: 20px;
    }
  }
}
</style>
